<template>
<div id="apptable" v-cloak>

    <b-card header="Modulistica" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="titolo" scope="row">{{row.value}}</template>
                        <template slot="categoria" scope="row">{{row.value}}</template>
                        <template slot="allegatoVis" scope="row">{{row.value}}</template>                 
                        <template slot="datainizio" scope="row">{{row.value | formatDate}}</template>
                        <template slot="datafine" scope="row">{{row.value | formatDate}}</template>  
                        <template slot="visibilitàVis" scope="row">{{row.value}}</template>                    

                        <template slot="modifica" scope="row">
                            <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-btn style="margin:0px 0px 1px 2px;" variant="warning" size="sm" @click.stop="del(row.item,row.index,$event.target)">Elimina</b-btn>
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                            <b-btn v-show="(row.item.allegato || '') != ''" style="margin:0px 0px 1px 2px;" size="sm" @click.stop="viewdoc(row.item,row.index,$event.target)">Visualizza</b-btn>
                        </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    <!-- Modal Component -->
    <b-modal v-model="deleteModal.show" title="Elimina">
        <p class="my-2">Confermi l'eliminazione della modulistica #{{deleteModal.id}}: {{deleteModal.nominativo}}?</p>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="delItem()" style="margin: 2px;">
                Conferma
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="deleteModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>
    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                titolo: {
                    label: 'Titolo',
                    sortable: true
                },
                categoria: {
                    label: 'Categoria',
                    sortable: true
                },
                allegatoVis: {
                    label: 'Allegato',
                    sortable: true
                },
                datainizio: {
                    label: 'Data inizio',
                    sortable: true
                },
                datafine: {
                    label: 'Data fine',
                    sortable: true
                },
                visibilitàVis: {
                    label: 'Visibilità',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            deleteModal: {
                id: null,
                nominativo: '',
                show: false
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY')
        }
    },
    methods: {
        insert() {
            this.$router.push('/app/dettagliomodulistica');                     
        },
        details(item, index, button) {
            this.$router.push({
                path: `/app/dettagliomodulistica/${item.id}`
            });
        },
        viewdoc(item, index, button) {
            window.open(item.allegato, '_blank');
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        del(item, index, button) {
            this.deleteModal.id = item.id;
            this.deleteModal.nominativo = item.titolo;
            this.deleteModal.show = true;
        },
        delItem() {

            var apptable = this;

            var token = localStorage.getItem('token');
            this.axios.delete(NAMESPACE + 'rest/modulistica/' + this.deleteModal.id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            //forse può essere fatta diversamente e meglio
                            for (var i = 0; i < apptable.items.length; i++) {
                                if (this.items[i].id == this.deleteModal.id) {
                                    this.items.splice(i, 1); //delete
                                    break;
                                }
                            }
                            this.deleteModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }

                    } catch (e) {

                        this.deleteModal.show = false;
                        apptable.showerror = true;
                        apptable.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {

                    this.deleteModal.show = false;
                    apptable.showerror = true;
                    apptable.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },

    },
    created: function () {

        

        if(!ctrlVismenu("L")){
            this.$router.replace('/accessdenied');
            return;
        }


        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/modulistica', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;

                        //console.log("Response: " + JSON.stringify(response.data.message));

                        let apptable = this;

                        var visibilità = new Visibilità();
                        apptable.items.forEach(function(element, index) {

                            //console.log("AAAA: " + JSON.stringify(element))

                            if((element.allegato || "") != ""){
                                var split = element.allegato.split('/');
                                element.allegatoVis = decodeURI(split[split.length - 1]);
                            }
                            else{
                                element.allegatoVis = "Nessuno"
                            }
                            
                            var today = moment(String(new Date())).format('YYYY-MM-DD');
                            if ((!(element.datainizio <= today && today <= element.datafine)) || ((element.allegato || '') == '')
                               ) {
                                element._rowVariant = 'danger';
                            }
                            
                            element.datainizio_ric = apptable.$options.filters.formatDate(element.datainizio);
                            element.datafine_ric = apptable.$options.filters.formatDate(element.datafine);                            
                            element.visibilitàVis = visibilità.getTipoByFlag(element.visibilita);

                            delete element.uteins; //per motivi di ricerca

                        });                        
                        
                        apptable.items = apptable.items.filter(function (element) {   
                            return ctrlViscategoria(element.id_categoria);
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
